import React from 'react';
import BaseTabComponent from './../BaseTabComponent';

export default class PropertyInformation extends BaseTabComponent {
    constructor(props) {
        super(props);
        this.onTableValueChange = this.onTableValueChange.bind(this);

    }

    onTableValueChange(tableIdentifier, rowCode, event, columnIndex) {
        this.props.valueChange('property-information-tab', tableIdentifier, rowCode, event.currentTarget.value, columnIndex);
    }


    render() {
        const tab = this.props.tabs['property-information-tab'];

        // Computing heavily-used values at the start of the render.
        const precomputedValues = BaseTabComponent.precomputeHeavilyUsedValues(this.props.tabs);
        return (
            <div className="PropertyInformation">
                <div className='Financials_list_columns'>
                    <div className='Financials_list_column'>
                        {BaseTabComponent.renderTableContainer(tab.tables['general-information'], [
                            this.renderTable(tab.tables, 'general-information', precomputedValues),
                            this.renderTable(tab.tables, 'other-information', precomputedValues)
                        ])}
                    </div>
                    <div className='Financials_list_column'>
                        {BaseTabComponent.renderTableContainer(tab.tables['links'], [
                            this.renderTable(tab.tables, 'links', precomputedValues)])}

                        {BaseTabComponent.renderTableContainer(tab.tables['parcel'], [
                            this.renderMatrixTable(tab.tables, 'parcel', precomputedValues)])}
                    </div>
                </div>
            </div>
        )
    }
}